import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { RouterLink } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationLink',
  props: {
    to: {},
    isExternalLink: { type: Boolean },
    class: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (!_ctx.isExternalLink)
    ? (_openBlock(), _createBlock(_unref(RouterLink), {
        key: 0,
        to: _ctx.to,
        class: _normalizeClass(props.class)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["to", "class"]))
    : (_openBlock(), _createElementBlock("a", {
        key: 1,
        href: _ctx.to,
        target: "_blank",
        class: _normalizeClass(props.class)
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
}
}

})